import { render, staticRenderFns } from "./ProcessDocumentsSignTab.vue?vue&type=template&id=0a838c66&scoped=true"
import script from "./ProcessDocumentsSignTab.vue?vue&type=script&lang=js"
export * from "./ProcessDocumentsSignTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a838c66",
  null
  
)

export default component.exports